module.exports = __webpack_public_path__ + "img/active_product3.0dd404e.png";